import React from "react";
import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./Route/MainRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Provider } from "react-redux";
import store from "./Rankers/redux/Store";

function App() {
  return (
     <Provider store={store}>
    <BrowserRouter>
      <MainRoutes />     
    </BrowserRouter>
    </Provider>
  );
}

export default App;
